import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

/**
 * This get to the param in the route called featureFlag
 * that contains the exact name of the flag inside the flags config
 * to validate if the user is able to open that section or not
 */
@Injectable({
  providedIn: 'root', // or specify the module where the guard is provided
})
export class FeatureGuard implements CanActivate {
  private router = inject(Router);
  private ftrFlagService = inject(FeatureFlagService);
  private localStorage = inject(LocalStorageService);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    if (route.data) {
      // const activeModule = this.localStorage.get('ModuleActive') ? 'creator' : this.localStorage.get('ModuleActive')

      // console.log("route.data['featureFlag'] > ",this.ftrFlagService.hasFlag(route.data['featureFlag']));
      // if(!this.ftrFlagService.hasFlag(route.data['featureFlag'])){
      //   if(state.url != '/creator/my-omniverse/universes') this.router.navigate(['/creator/my-omniverse/universes']);
      //   else if(state.url == '/creator/my-omniverse/universes') this.router.navigate(['/profile']);
      //   return of(false)
      // }

      // NOTE: Up commented because old behaviour of switch parent modules, creator and player.
      if (this.ftrFlagService.hasFlag(route.data['featureFlag']))
        return of(true); // check first level flags
      else if (this.ftrFlagService.hasFunctionality(route.data['featureFlag']))
        return of(true); // check for functionalities
      else return of(false);
    }
    return of(true);
  }
}
